import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import MuiFormControlLabel from '@mui/material/FormControlLabel';
import * as React from 'react';
import { Box } from '../box';
import { Typography } from '../typography';
const SWITCH_BASE_PADDING = 9;
export const FormControlLabel = MuiFormControlLabel;
export const FormControlLabelWithDescription = (props) => {
    const { label, description, ...muiProps } = props;
    return (_jsx(MuiFormControlLabel, { ...muiProps, sx: { alignItems: 'flex-start' }, label: _jsxs(Box, { paddingTop: `${SWITCH_BASE_PADDING}px`, children: [label, _jsx(Typography, { variant: "body2", color: "text.secondary", children: description })] }) }));
};
export const formControlStyle = {
    MuiFormControlLabel: {
        styleOverrides: {
            root: {
                marginBottom: 0,
                maxWidth: 'max-content',
                userSelect: 'none'
            },
            label: ({ theme }) => ({
                fontSize: theme.typography.body1.fontSize
            })
        }
    }
};
